import {
  Container,
  Grid,
  Box,
  makeStyles,
  useTheme,
  Slide,
  Fade,
  Grow,
  Typography,
  Avatar,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import Axios from "axios";
import { Helmet } from "react-helmet-async";
import { Loading } from "../../components/shared/loading";
import { TypingQuote } from "../../components/shared/TypingQuote";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    backgroundImage: 'linear-gradient(rgba(76, 0, 76, 0.85), rgba(76, 0, 76, 0.9)), url("/static/our_team.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    minHeight: "35vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroContent: {
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    textShadow: "0 2px 15px rgba(0,0,0,0.3)",
  },
  heroDivider: {
    width: 40,
    height: 2,
    background: "rgba(255,255,255,0.5)",
    margin: "12px auto",
    borderRadius: 2,
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
  },
  section: {
    padding: "40px 0",
    background: "#fafafa",
  },
  sectionWhite: {
    padding: "40px 0",
    background: "#ffffff",
  },
  sectionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 8,
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#666666",
    textAlign: "center",
    maxWidth: 450,
    margin: "0 auto 28px",
    lineHeight: 1.5,
  },
  teamCard: {
    position: "relative",
    borderRadius: 20,
    overflow: "hidden",
    width: "100%",
    height: 340,
    cursor: "default",
    transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
    background: "#f8f4f8",
    [theme.breakpoints.down('sm')]: {
      height: 300,
      borderRadius: 16,
    },
    [theme.breakpoints.down('xs')]: {
      height: 280,
    },
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 20px 50px rgba(76, 0, 76, 0.18)",
    },
    "&:hover $teamImage": {
      transform: "scale(1.04)",
    },
    "&:hover $teamGlass": {
      background: "rgba(76, 0, 76, 0.82)",
      backdropFilter: "blur(18px)",
    },
    "&:hover $teamDesc": {
      opacity: 1,
      maxHeight: 60,
      marginTop: 8,
    },
  },
  teamImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block",
    border: "none",
    padding: 16,
    transition: "transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1)",
  },
  teamGlass: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    background: "rgba(76, 0, 76, 0.65)",
    backdropFilter: "blur(12px)",
    padding: "16px 20px",
    transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
    borderTop: "1px solid rgba(255,255,255,0.08)",
    textAlign: "center",
    [theme.breakpoints.down('sm')]: {
      padding: "14px 16px",
    },
  },
  teamAccent: {
    width: 24,
    height: 2,
    background: "rgba(255,255,255,0.4)",
    borderRadius: 2,
    margin: "0 auto 10px",
  },
  teamName: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#ffffff",
    marginBottom: 2,
    letterSpacing: "0.3px",
  },
  teamDesignation: {
    fontSize: "0.7rem",
    color: "rgba(255,255,255,0.7)",
    fontWeight: 400,
    textTransform: "uppercase",
    letterSpacing: "1px",
  },
  teamDesc: {
    fontSize: "0.72rem",
    color: "rgba(255,255,255,0.8)",
    lineHeight: 1.5,
    opacity: 0,
    maxHeight: 0,
    overflow: "hidden",
    transition: "all 0.4s ease",
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
  },
  quoteSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "12px",
    padding: "28px 24px",
    marginTop: 32,
    textAlign: "center",
  },
  quoteText: {
    fontSize: "0.9rem",
    color: "#ffffff",
    lineHeight: 1.6,
    fontStyle: "italic",
    maxWidth: 700,
    margin: "0 auto 12px",
  },
  quoteAuthor: {
    color: "#ffffff",
    fontSize: "0.8rem",
    fontWeight: 600,
    opacity: 0.9,
  },
}));
  
  export const OurTeam = () => {
    const theme = useTheme();
  
    const classes = useStyles();
    const [team1, setTeam1] = useState([]);
    const [team2, setTeam2] = useState([]);
    const [metaTitle, setMetaTitle] = useState("");
    const [metaDesc, setMetaDesc] = useState("");
    const [metaKeywords, setMetaKeywords] = useState("");
    const [isloading, setIsloading] = useState(true);
  
    const handleClick = () => {
      const anchor = document.querySelector("#back-to-top-anchor");
  
      if (anchor) {
        anchor.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };
  
    useEffect(() => {
      getMetaData();
    }, []);
  
    const getMetaData = async () => {
      const formData = new FormData();
      formData.append("page", 8);
      await Axios.post("/api/getmetadata", formData, {
        headers: { headKey: headKey },
      }).then((res) => {
        if (res.data.status) {
          setMetaTitle(res.data.data.meta_title);
          setMetaKeywords(res.data.data.meta_keywords);
          setMetaDesc(res.data.data.meta_desc);
          
          
        }
      });
      await  Axios.post("/api/get_all_team", {
        headers: { headKey: headKey },
      }).then((res) => {
        
        if (res.data.status) {
          setTeam1(res.data.team1);
          setTeam2(res.data.team2);
          setIsloading(false);
          handleClick();
          // console.log(res.data.status);
          // setData(ReactHtmlParser(res.data.data.description));
        }
      });
    };
  
      
    return (
      <div>
        <Helmet>
          <title>{metaTitle}</title>
          <meta name="description" content={metaDesc} />
          <meta name="keywords" content={metaKeywords}></meta>
        </Helmet>
        {/* Hero Section */}
        <Box className={classes.heroSection}>
          <Fade in={true} timeout={1000}>
            <Box className={classes.heroContent}>
              <Typography className={classes.heroTitle}>
                Our Team
              </Typography>
              <Box className={classes.heroDivider} />
              <Typography className={classes.heroSubtitle}>
                The Brains Behind Our Breakthroughs
              </Typography>
            </Box>
          </Fade>
        </Box>

        {isloading ? (
          <Loading />
        ) : (
          <>
          {/* Leadership Team Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Leadership Team
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Get to know our leaders, their expertise, and the vision that guides us
                  </Typography>
                </Box>
              </Slide>

              <Grid container spacing={4}>
                {team1.map((team, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Grow in={true} timeout={800 + index * 150}>
                      <Box className={classes.teamCard}>
                        <img
                          src={"/static/team/" + team.image}
                          alt={team.name}
                          className={classes.teamImage}
                        />
                        <Box className={classes.teamGlass}>
                          <Box className={classes.teamAccent} />
                          <Typography className={classes.teamName}>
                            {team.name}
                          </Typography>
                          <Typography className={classes.teamDesignation}>
                            {team.designation}
                          </Typography>
                          <Typography className={classes.teamDesc}>
                            {team.description}
                          </Typography>
                        </Box>
                      </Box>
                    </Grow>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Box>

          {/* Core Developers Section */}
          <Box className={classes.sectionWhite}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Core Developers
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Discover the talented developers behind our cutting-edge solutions
                  </Typography>
                </Box>
              </Slide>

              <Grid container spacing={4}>
                {team2.map((team, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Grow in={true} timeout={800 + index * 150}>
                      <Box className={classes.teamCard}>
                        <img
                          src={"/static/team/" + team.image}
                          alt={team.name}
                          className={classes.teamImage}
                        />
                        <Box className={classes.teamGlass}>
                          <Box className={classes.teamAccent} />
                          <Typography className={classes.teamName}>
                            {team.name}
                          </Typography>
                          <Typography className={classes.teamDesignation}>
                            {team.designation}
                          </Typography>
                          <Typography className={classes.teamDesc}>
                            {team.description}
                          </Typography>
                        </Box>
                      </Box>
                    </Grow>
                  </Grid>
                ))}
              </Grid>

              {/* Quote Section */}
              <Fade in={true} timeout={1400}>
                <Box className={classes.quoteSection}>
                  <TypingQuote
                    text={`"At Arawinz, our ethos is rooted in the seamless fusion of creativity and commitment, driving us to provide outstanding results. Our path is defined by an unwavering dedication to surpassing expectations and an earnest endeavor to grasp and cater to our clients' unique requirements. As a collective, we transcend mere collaboration – we are visionaries shaping tomorrow, piecing together a more intelligent and interconnected reality."`}
                    className={classes.quoteText}
                  />
                  <Typography className={classes.quoteAuthor}>
                    — Dr. P. Srinivas Rao, CEO
                  </Typography>
                </Box>
              </Fade>
            </Container>
          </Box>
        </>
        )}
     
      </div>
    );
  };
  

